import client from "./client";

const getpolylinedate_endpoint = "/Dashboard/GetTrails";
const getfilters_endpoint = "/Dashboard/GetFilters";
const savePoi_endpoint = "/Dashboard/SavePOI";
const deletePOI_endpoint = "/Dashboard/DeletePOI";
const getPOIsListByStageId_endpoint = "/Dashboard/GetPOIsListByStageId";
const getfurtherdetails_endpoint = "/Dashboard/GetStageDataById";
const getpolylinedateforgpstracker_endpoint = "/Dashboard/GetGpsTrackerTrail";
const trailFromRawData_endpoint = "/Dashboard/TrailFromRawData";

// const getpolylinedate_endpoint = "/md-api/gettrails";
// const getfilters_endpoint = "/md-api/getfilters";
// const savePoi_endpoint = "/md-api/savepoi";
// const deletePOI_endpoint = "/md-api/deletepoi";
// const getPOIsListByStageId_endpoint = "/md-api/getpoislistbystageid";
// const getfurtherdetails_endpoint = "/md-api/getstagedatabyid";
// const getpolylinedateforgpstracker_endpoint = "/md-api/getgpstrackertrail";
// const trailFromRawData_endpoint = "/md-api/trailfromrawdata";

const getpolylinedate = async (
  editionId,
  stageId,
  teamIds,
  forFullEditionTrail = false
) => {
  let formData = new FormData();
  formData.append("editionId", editionId);
  formData.append("stageId", stageId);
  formData.append("forFullEditionTrail", forFullEditionTrail);

  // Since `teamIds` is an array, we append each element individually.
  teamIds.forEach((teamId, index) => {
    formData.append(`teamIds[${index}]`, teamId);
  });

  // console.log("FormData Payload", formData);
  return client.post(getpolylinedate_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getfilters = async (editionId, stageId, teamIds, showGpsTrackerTrail) => {
  let formData = new FormData();
  formData.append("editionId", editionId);
  formData.append("stageId", stageId);
  formData.append("forGpsTracker", showGpsTrackerTrail);

  // Since `teamIds` is an array, we append each element individually.
  teamIds.forEach((teamId, index) => {
    formData.append(`teamIds[${index}]`, teamId);
  });

  // console.log("FormData Payload", formData);
  return client.post(getfilters_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getfurtherdetails = async (stageId, teamIds) => {
  let formData = new FormData();
  formData.append("stageId", stageId);

  // Since `teamIds` is an array, we append each element individually.
  teamIds.forEach((teamId, index) => {
    formData.append(`teamIds[${index}]`, teamId);
  });

  // console.log("FormData Payload", formData);
  return client.post(getfurtherdetails_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getpolylinedateforgpstracker = async (
  deviceId,
  dateFrom,
  timeFrom,
  dateTo,
  timeTo,
  requestFromPool = false,
  loadAllMarkers = false,
  gpsMarkerSpanInSeconds
) => {
  let formData = new FormData();
  formData.append("deviceId", deviceId);
  formData.append("dateFrom", dateFrom);
  formData.append("timeFrom", timeFrom);
  formData.append("dateTo", dateTo);
  formData.append("timeTo", timeTo);
  formData.append("requestFromPool", requestFromPool);
  formData.append("loadAllMarkers", loadAllMarkers);
  formData.append("gpsMarkerSpanInSeconds", gpsMarkerSpanInSeconds);

  // console.log("FormData Payload", formData);
  return client.post(getpolylinedateforgpstracker_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const trailFromRawData = async (rawDataId) => {
  let formData = new FormData();
  formData.append("gpsPushRawDataPerRequestId", rawDataId);

  // console.log("FormData Payload", formData);
  return client.post(trailFromRawData_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const savePoi = async (name, radius, lat, lng, id, stageId) => {
  let formData = new FormData();
  formData.append("Name", name);
  formData.append("Lat", lat);
  formData.append("Lng", lng);
  formData.append("Radius", radius);
  formData.append("Id", id);
  formData.append("StageId", stageId);

  // console.log("FormData Payload", formData);
  return client.post(savePoi_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getPOIsListByStageId = async (stageId) => {
  let formData = new FormData();
  formData.append("stageId", stageId);

  return client.post(getPOIsListByStageId_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deletePOI = async (id) => {
  let formData = new FormData();
  formData.append("poiId", id);

  // console.log("FormData Payload", formData);
  return client.post(deletePOI_endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getpolylinedate,
  getfilters,
  getfurtherdetails,
  getpolylinedateforgpstracker,
  trailFromRawData,
  savePoi,
  getPOIsListByStageId,
  deletePOI,
};
